import style from "./index.module.scss";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Spin,
  Select,
  DatePicker,
  Button,
  message,
  Tooltip,
  Flex,
  Modal,
  Typography,
} from "antd";
import { podOrderList } from "../../../../../api/personal";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { SvgIcon } from "@/components/SvgIcon";
const { RangePicker } = DatePicker;
import { IS_MOBILE, goHref } from "@/utils/tool";
import InfiniteScroll from "react-infinite-scroll-component";
import { fetchAttorney } from "@/api/common";
import {
  PodOrderStatus,
  podOrderStatusList,
  podOrderStatusMap,
} from "@/utils/contants";
import { cancelPodOrder, markPodOrderReceipt } from "@/api/order";
import PodConfirm from "../PodConfirm";
import { SmileFilled, SmileOutlined } from "@ant-design/icons";

type OrderProps = {
  scrollableTargetId: string;
};

const PodOrder: React.FC<OrderProps> = ({ scrollableTargetId }) => {
  const { t } = useTranslation();
  const [pageNumber, setPageNumber] = useState(1);
  const [orderList, setOrderList] = useState<PodOrder[]>([]);
  //   const [orderCount, setOrderCount] = useState(0);
  const [spinning, setSpinning] = useState(true);
  const [times, setTimes] = useState([]);
  const [status, setStatus] = useState(0);
  const [messageApi, contextHolder] = message.useMessage();
  const [curOrder, setCurOrder] = useState<PodOrder>();

  const fetchOrderList = async (params, type: "scroll" | "new") => {
    setSpinning(true);
    const orderRes = await podOrderList<{
      count: number;
      list: Array<PodOrder>;
      n: number;
      p: number;
    }>(params);
    setSpinning(false);
    if (orderRes.code === 0) {
      const { count, list } = orderRes.data;
      //   setOrderCount(count);
      //   const item: PodOrder = {
      //     article_title: "期刊标题",
      //     delivery_time: 0,
      //     journal_name: "string",
      //     logistics_company: "顺丰快递",
      //     logistics_no: "SF12dssddssddssdsda",
      //     number: 1,
      //     order_id: "dsaadsadsasdasdads",
      //     price: 110,
      //     status: 1,
      //     total_amount: 120,
      //   };
      //   list.push(item);
      if (type === "scroll") {
        setOrderList((pre) => [...pre, ...list]);
      } else {
        setOrderList(list);
      }
      return;
    }
    messageApi.error(orderRes.msg);
  };

  /**
   * 订单状态列表
   */
  const orderStatusList = useMemo(() => {
    const statusList = [{ value: 0, label: "全部" }, ...podOrderStatusList].map(
      (item) => {
        return { ...item, label: t(item.label) };
      }
    );
    return statusList;
  }, [t]);

  useEffect(() => {
    fetchOrderList(
      {
        status: status,
        pay_time_min: times[0]?.startOf("day").unix(),
        refund_status: times[1]?.add(1, "day").startOf("day").unix(),
        p: 1,
        n: 10,
      },
      "new"
    );
  }, []);

  useEffect(() => {
    pageNumber > 1 &&
      fetchOrderList(
        {
          status: status,
          pay_time_min: times[0]?.startOf("day").unix(),
          refund_status: times[1]?.add(1, "day").startOf("day").unix(),
          p: pageNumber,
          n: 10,
        },
        "scroll"
      );
  }, [pageNumber]);

  /**
   * 时间发生改变时
   * @param times
   */
  const onChangeTime = (times) => {
    if (!times) {
      setTimes([]);
      return;
    }
    if (times[0] && times[1]) {
      setTimes(times);
    }
  };

  const submitSearch = () => {
    const params = {
      status: status,
      pay_time_min: times[0]?.startOf("day").unix(),
      pay_time_max: times[1]?.add(1, "day").startOf("day").unix(),
      p: 1,
      n: 10,
    };
    // 重置列表与页码
    setPageNumber(1);
    setOrderList([]);
    fetchOrderList(params, "new");
  };

  const resetSearch = () => {
    setStatus(0);
    setTimes([]);
    setPageNumber(1);
    setOrderList([]);
    fetchOrderList(
      {
        p: 1,
        n: 10,
      },
      "new"
    );
  };

  /**
   * 确认取消订单
   * @param order
   */
  const confirmOrderHandel = async (order: PodOrder) => {
    const res = await cancelPodOrder({ order_id: order.order_id });
    if (res.code === 0) {
      messageApi.success(t("订单已取消"));
      fetchOrderList(
        {
          status: status,
          pay_time_min: times[0]?.startOf("day").unix(),
          refund_status: times[1]?.add(1, "day").startOf("day").unix(),
          p: 1,
          n: 10,
        },
        "new"
      );
      return;
    }
    messageApi.error(res.msg);
  };

  /**
   * 取消订单
   * @param order
   */

  /**
   * 打开确认收货弹框
   */

  /**
   * 确认收货
   * @param order
   */
  const confirmOrderReceiptHandel = async (order: PodOrder) => {
    // 确认收货逻辑
    const res = await markPodOrderReceipt({ order_id: order.order_id });
    if (res.code === 0) {
      messageApi.success(t("确认期刊已收到"));
      fetchOrderList(
        {
          status: status,
          pay_time_min: times[0]?.startOf("day").unix(),
          refund_status: times[1]?.add(1, "day").startOf("day").unix(),
          p: 1,
          n: 10,
        },
        "new"
      );
      return;
    }
    messageApi.error(res.msg);
  };

  /**
   * 关闭定购当期期刊
   */
  const closePodConfirm = () => {
    setCurOrder(undefined);
  };

  /**
   * 取消确认收货
   * @param order
   */

  useEffect(() => {
    if (IS_MOBILE) {
      const rangePickerDom = document.getElementById("range-picker-container");
      if (rangePickerDom) {
        let inputElements = rangePickerDom.getElementsByTagName("input");
        for (var i = 0; i < inputElements.length; i++) {
          inputElements[i].readOnly = true;
        }
      }
    }
  }, []);

  return (
    <>
      {contextHolder}
      <section className="content-wrapper">
        <section className="search-wrapper">
          <div className="search">
            <div className="item">
              <span className="title">{t("订单状态")}</span>
              <Select
                value={status}
                options={orderStatusList}
                style={{ width: 180 }}
                onChange={(value) => setStatus(value)}
              />
            </div>
            <div className="item" id="range-picker-container">
              <span
                className="title"
                style={
                  IS_MOBILE ? { display: "inline-block", marginBottom: 8 } : {}
                }
              >
                {t("支付时间")}
              </span>
              <RangePicker
                style={{ width: 300 }}
                format="YYYY-MM-DD"
                onChange={onChangeTime}
                value={times as any}
                popupClassName={`${IS_MOBILE ? "mobile-range-picker" : ""}`}
                getPopupContainer={(node) => node.parentElement ?? node}
              />
            </div>
          </div>
          <div className="btn">
            <Button onClick={resetSearch}>{t("重置")}</Button>
            <Button type="primary" onClick={submitSearch}>
              {t("查询")}
            </Button>
          </div>
        </section>
        {orderList.length !== 0 ? (
          <section className="order-list-wrapper" id={scrollableTargetId}>
            <>
              <InfiniteScroll
                dataLength={orderList.length}
                next={() => setPageNumber(pageNumber + 1)}
                hasMore={true}
                loader={null}
                scrollableTarget={scrollableTargetId}
              >
                {orderList.map((item, index) => (
                  <div className="order-item" key={index}>
                    <div className="number">
                      <div>
                        <span>{t("支付号")}:</span>
                        {item.order_id}
                      </div>
                      <div>{t(podOrderStatusMap[item.status])}</div>
                    </div>
                    <section className="info-wrapper">
                      <div className="periodicals">
                        <span className="title">{t("期刊名称")}:</span>
                        <Tooltip
                          placement="top"
                          title={item.journal_name}
                          className="name"
                          overlayStyle={{
                            fontSize: "1rem",
                            maxWidth: "500px",
                          }}
                          color="rgba(39, 46, 59, 0.9)"
                        >
                          <span>{item.journal_name}</span>
                        </Tooltip>
                      </div>
                      <div className="article-title">
                        <span className="title">{t("文章标题")}:</span>
                        <Tooltip
                          placement="top"
                          title={item.article_title}
                          className="name"
                          overlayStyle={{
                            fontSize: "1rem",
                            maxWidth: "500px",
                          }}
                          color="rgba(39, 46, 59, 0.9)"
                        >
                          <span className="title-info">
                            {item.article_title}
                          </span>
                        </Tooltip>
                      </div>
                      <div className="article-title">
                        <span className="title">{t("定购数量")}:</span>
                        <span className="title-info">{item.number}</span>
                      </div>
                      {item.logistics_company && (
                        <>
                          <div className="article-title">
                            <span className="title">{t("物流公司")}:</span>
                            <span className="title-info">
                              {item.logistics_company}
                            </span>
                          </div>
                          <div className="article-title">
                            <span className="title">{t("物流单号")}:</span>
                            <span className="title-info">
                              <Typography.Paragraph
                                style={{ marginBottom: 0 }}
                                className={style.copy}
                                copyable={{
                                  icon: [
                                    <SvgIcon
                                      icon="icon-fuzhi"
                                      width={16}
                                      height={16}
                                    ></SvgIcon>,
                                  ],
                                }}
                              >
                                {item.logistics_no}
                              </Typography.Paragraph>
                            </span>
                          </div>
                        </>
                      )}
                      <div className="pay-time">
                        <span className="title">{t("支付时间")}:</span>
                        {item.pay_time
                          ? dayjs(item.pay_time * 1000).format(
                              "YYYY-MM-DD HH:mm:ss"
                            )
                          : "-"}
                      </div>
                      <div className="pay-amount">
                        <div className="money">
                          <span>{t("支付金额")}:</span>
                          <span>¥ {item.total_amount.toFixed(2)}</span>
                        </div>
                        <Flex gap={6}>
                          {item.status === PodOrderStatus.PendingPayment && (
                            <>
                              <Button
                                type="link"
                                className="hold"
                                onClick={() =>
                                  Modal.confirm({
                                    title: t("确认"),
                                    content: t("确认取消订单 ?"),
                                    okText: t("确认"),
                                    cancelText: t("取消"),
                                    onOk: () => confirmOrderHandel(item),
                                  })
                                }
                              >
                                {t("取消支付")}
                              </Button>

                              <Button
                                type="primary"
                                className="hold"
                                onClick={() => setCurOrder(item)}
                              >
                                {t("继续支付")}
                              </Button>
                            </>
                          )}
                          {item.status === PodOrderStatus.Shipped && (
                            <Button
                              type="primary"
                              className="hold"
                              onClick={() =>
                                Modal.confirm({
                                  title: t("确认"),
                                  content: t("确认期刊已收到") + " ?",
                                  okText: t("确认"),
                                  cancelText: t("取消"),
                                  onOk: () => confirmOrderReceiptHandel(item),
                                })
                              }
                            >
                              {t("确认收货")}
                            </Button>
                          )}
                        </Flex>
                      </div>
                    </section>
                  </div>
                ))}
              </InfiniteScroll>
              {spinning && (
                <div className="spin-wrapper">
                  <Spin size="large" spinning={spinning} />
                </div>
              )}
            </>
          </section>
        ) : (
          <div className="empty-content" style={{ marginTop: "1.583rem" }}>
            <SvgIcon
              icon={status || times.length ? "icon-wujieguo" : "icon-wuliebiao"}
            />
            {status || times.length ? t("暂无相匹配的订单") : t("暂无订单")}
          </div>
        )}

        {curOrder && (
          <PodConfirm
            order={curOrder}
            isProceedPay={true}
            cancelModal={closePodConfirm}
          />
        )}
      </section>
    </>
  );
};

export default PodOrder;
